/* eslint-disable no-useless-constructor */
import React, { useRef, useEffect, useState, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getHarpApplicationPDF } from "../../../../redux/reducers/apiReducers/postHarpApplicationReducer";
import styles from "./Confirmation.module.scss";
import PrintComponent from "./PrintComponent";
import SaveCopy from "./SaveCopy";
import OtherGrantQuestions from "../../../../shared/components/OtherGrantQuestions";
import { Link } from "@mui/material";

export const PrintContent1 = ({
  t,
  i18n,
  paymentTransactionNum,
  transId,
  transOwner
}) => {
  const { harpApplicationId } = useSelector(
    (state) => state.harpApplicationReducer
  );
  const { personalInformation } = useSelector((state) => state.app);
  const submitResponse = useSelector(
    (state) => state.harpApplicationReducer
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [pdfData, setPDFData] = useState(null);
  useEffect(() => {



    setPDFData(submitResponse.pdf);


  }, [submitResponse]);

  return (
    <div className={"container"}>
      <div className="row" style={{ paddingTop: "1em" }}></div>

      <div className="print_no_display">
        <div className="row">
          <div style={{ display: "flex", flexGrow: 1 }}>
            {" "}
            <div className={styles["display_flex"]}>
              <div
                style={{ paddingLeft: "10px" }}
                className={styles["back_center"]}
              >
                {typeof InstallTrigger !== "undefined" ||
                /*@cc_on!@*/ false ||
                  !!document.documentMode ? null : (
                  <PrintComponent
                    pdfData={pdfData}
                    transId={transId}
                    transOwner={transOwner}
                  />
                )}
                <SaveCopy
                  pdfData={pdfData}
                  transId={transId}
                  confirmationId={submitResponse?.confirmationId}
                  transOwner={transOwner}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ConfirmationView = ({ t, i18n, setIsError }) => {
  const pageElem = useRef();
  const language = i18n.language;
  const isFrench = language === "fr";
  const optOutText = isFrench ? "désinscrire" : "opt-out";

  const textParts = t("confirmation.opt-out").split(
    new RegExp(`(${optOutText})`, "i")
  );

  const { personalInformation } = useSelector((state) => state.app);
  const submitResponse = useSelector(
    (state) => state.harpApplicationReducer
  );
  const datesData = useSelector((state) => state.datesReducer);
  let currentLanguageDates;
  if (datesData) {
    currentLanguageDates = datesData[i18n.language];
  }

  const billProofDate = currentLanguageDates?.endDate || null;

  const emailStr = useMemo(() => {
    return personalInformation?.email;
  }, [personalInformation]);

  return (
    <React.Fragment>
      <div ref={pageElem} style={{ marginBottom: "2rem" }}>
        <div className="container">
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px"
              }}
            >
              <div className={"col-xs-1 " + styles["success_margin_right"]}>
                <i className="fa fa-check-circle fa-2x" aria-hidden="true"></i>
              </div>
              <div
                style={{ flexGrow: 1, backgroundColor: "green", width: "5px" }}
              />
            </div>

            <div style={{ flexGrow: 1 }}>
              {/*  */}
              <div className="col-xs-12">
                <div className="row">
                  <div className="col-xs-12 col-sm-8">
                    <h1 style={{ color: "green" }}>
                      {t("confirmation.title")}
                    </h1>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 col-sm-8">
                    <h3 style={{ marginBottom: 0 }}>
                      {t("confirmation.reference_number")}{" "}
                      <strong>{submitResponse?.confirmationId}</strong>
                    </h3>
                    {t("confirmation.we_have_emailed")}{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <h3>{t("confirmation.what_happens_next")}</h3>
              <div className="row">
                <div className="col-xs-11 col-sm-8">
                  <p style={{ marginBottom: 0 }}>
                    {t("confirmation.next_note")}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-11 col-sm-8">
                  <h3>{t("confirmation.will_we_contact")}</h3>
                  {t("confirmation.will_we_contact_note")}
                  <p style={{ marginBottom: 0, marginTop: "20px" }}>
                    {t("confirmation.will_we_contact_note_2")}
                  </p>
						{language === "en" ? (
                    <Link
                      href="https://antifraudcentre-centreantifraude.ca/report-signalez-eng.htm"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      {t("confirmation.anti_fraud_link")}
                    </Link>
                  ) : (
                    <Link
                      href="https://antifraudcentre-centreantifraude.ca/report-signalez-fra.htm"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      {t("confirmation.anti_fraud_link")}
                    </Link>
                  )}

                </div>
              </div>

              <div className="row">
                <div className="col-xs-11 col-sm-8">
                  <h3>{t("confirmation.if_approved")}</h3>
                  {t("confirmation.if_approved_note")}
                </div>
              </div>
              <div className="row">
                <div className="col-xs-11 col-sm-8">
                  <h3>{t("confirmation.banking_info")}</h3>
                  {t("confirmation.banking_info_note")}
                  {language === "en" ? (
                    <Link
                      href="https://www.canada.ca/en/revenue-agency/services/about-canada-revenue-agency-cra/direct-deposit.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      {t("confirmation.banking_info_link")}
                    </Link>
                  ) : (
                    <Link
                      href="https://www.canada.ca/fr/agence-revenu/services/a-propos-agence-revenu-canada-arc/depot-direct.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      {t("confirmation.banking_info_link")}
                    </Link>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-xs-11 col-sm-8">
                  <h3>{t("confirmation.income_tax").replace(
                    "#YEAR",
                    currentLanguageDates?.taxFiled
                  )}</h3>
                  {t("confirmation.income_tax_note").replace(
                    "#YEAR",
                    currentLanguageDates?.taxFiled
                  )}
                  <p style={{ marginBottom: 0, marginTop: "20px" }}>
                    {t("confirmation.income_tax_note_2")}
                  </p>
                </div>
              </div>

              <OtherGrantQuestions />

              <div className="row">
                <div className="col-xs-11 col-sm-8">
                  <h3>{t("confirmation.future_research_studies")}</h3>
                  {t("confirmation.future_research_consent")}
                  <span>{currentLanguageDates?.contactByDate}</span>
                  <span>{"."}</span>
                  <p style={{ marginBottom: 0, marginTop: "20px" }}>
                    {textParts.map((text, index) =>
                      text.match(new RegExp(optOutText, "i")) ? (
                        <React.Fragment key={index}>
                          <Link
                            href={
                              isFrench
                                ? "http://surveys.novascotia.ca/TakeSurvey.aspx?SurveyID=n2K1979MH#"
                                : "https://surveys.novascotia.ca/TakeSurvey.aspx?SurveyID=n2K17564J#"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ cursor: "pointer" }}
                          >
                            {text}
                          </Link>
                        </React.Fragment>
                      ) : (
                        <span key={index}>{text}</span>
                      )
                    )}
                  </p>
                </div>
              </div>
              <div
                className="col-xs-12 col-sm-8"
                style={{ paddingTop: ".5em" }}
              >
                <h3>{t("otherGrantQuestions.questions")}</h3>
                <h5>
                  {t("otherGrantQuestions.contact")
                    .split(/(902-424-5200|1-800-670-4357)/)
                    .map((text, index) =>
                      text.match(/902-424-5200|1-800-670-4357/) ? (
                        <Link key={index} href={`tel:${text}`}>
                          {text}
                        </Link>
                      ) : (
                        text
                      )
                    )}
                </h5>
              </div>

              <div className="row">
                <div className="col-xs-11 col-sm-8">
                  <h3>{t("confirmation.print_or_save")}</h3>
                  {t("confirmation.print_or_save_note")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <PrintContent1
          i18n={i18n}
          t={t}
          emailAddress={emailStr}
          paymentTransactionNum={submitResponse?.confirmationId}
        />
      </div>
    </React.Fragment>
  );
};

export default withTranslation("common")(ConfirmationView);
